export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

export const resetPasswordSuccess = () => ({
    type: RESET_PASSWORD_SUCCESS,
});
